import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, CreditCard, Smartphone, Building2, Banknote, Star, ArrowRight } from 'lucide-react';
import { trackPixel } from '../utils/metaPixel';
const plans = [{
  id: 'base',
  name: 'MEGA PACK COMPLETO',
  summary: '18 tomos clínicos + 5 bonos',
  oldPrice: '$97.000',
  price: '$19.990',
  href: 'https://kinesiologia-sistema-clinico-completo.impultienda.ar/checkout',
  cta: 'QUIERO EL MEGA PACK AHORA',
  includes: ['18 tomos clínicos completos', '5 bonos incluidos sin costo', 'Acceso y descarga inmediata', 'Imprimís las veces que necesites', 'Acceso de por vida', 'Garantía de 7 días']
}];
export function Purchase() {
  const [selected, setSelected] = useState('base');
  const activePlan = plans.find(p => p.id === selected) || plans[0];
  return <section id="compra" className="py-16 md:py-24 px-4 bg-white" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <div className="text-center mb-12" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-129">
            Elegí cómo querés pagarlo
          </h2>
          <p className="text-xl text-brand-teal font-bold uppercase tracking-wider" data-id="element-130">
            🥇 PAGO ÚNICO — LA OPCIÓN MÁS CONVENIENTE
          </p>
        </div>

        {/* Plan Selector (only shown when more than one plan) */}
        {plans.length > 1 && <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-4 mb-10" data-id="element-131">
            {plans.map(plan => {
          const isActive = plan.id === selected;
          return <button key={plan.id} type="button" onClick={() => setSelected(plan.id)} className={`w-full text-left rounded-2xl border-2 p-5 md:p-6 transition-all ${isActive ? 'border-brand-teal bg-brand-teal/5 shadow-lg' : 'border-gray-200 bg-white hover:border-brand-teal/40'}`} data-id="element-132">
                  <div className="flex items-center gap-4" data-id="element-133">
                    <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isActive ? 'border-brand-teal bg-brand-teal' : 'border-gray-300'}`} data-id="element-134">
                      {isActive && <span className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-135" />}
                    </span>
                    <div className="flex-grow" data-id="element-136">
                      <div className="flex items-center gap-2 flex-wrap" data-id="element-137">
                        <h3 className="text-lg md:text-xl font-bold text-brand-charcoal" data-id="element-138">
                          {plan.name}
                        </h3>
                        {plan.badge && <span className="inline-flex items-center gap-1 bg-brand-amber text-brand-charcoal text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wide" data-id="element-139">
                            <Star size={12} fill="currentColor" data-id="element-140" />
                            {plan.badge}
                          </span>}
                      </div>
                      <p className="text-sm text-gray-500 mt-0.5" data-id="element-141">
                        {plan.summary}
                      </p>
                    </div>
                    <div className="text-right flex-shrink-0" data-id="element-142">
                      <p className="text-sm text-gray-400 line-through" data-id="element-143">
                        {plan.oldPrice}
                      </p>
                      <p className={`text-2xl md:text-3xl font-black ${isActive ? 'text-brand-teal' : 'text-brand-charcoal'}`} data-id="element-144">
                        {plan.price}
                      </p>
                    </div>
                  </div>
                </button>;
        })}
          </motion.div>}

        {/* Selected plan details + CTA */}
        <div className="bg-brand-teal rounded-3xl p-1 md:p-2 shadow-2xl mb-16" data-id="element-145">
          <div className="bg-white rounded-[22px] p-6 md:p-10" data-id="element-146">
            <div className="text-center mb-8" data-id="element-147">
              <h3 className="text-xl md:text-2xl font-bold text-brand-charcoal" data-id="element-148">
                {activePlan.name}
              </h3>
            </div>

            <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-149">
              {activePlan.includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-150">
                  <Check className="text-brand-teal flex-shrink-0 mt-0.5" size={22} strokeWidth={3} data-id="element-151" />
                  <span className="text-base md:text-lg font-medium text-gray-700" data-id="element-152">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="text-center border-t border-gray-100 pt-8" data-id="element-153">
              <p className="text-gray-500 line-through text-lg mb-2" data-id="element-154">
                VALOR REAL: {activePlan.oldPrice} ARS
              </p>
              <div className="mb-2" data-id="element-155">
                <span className="text-sm font-bold text-brand-amber uppercase tracking-widest bg-brand-amberLight px-3 py-1 rounded-full" data-id="element-156">
                  HOY
                </span>
              </div>
              <p className="text-5xl md:text-6xl font-black text-brand-charcoal mb-2" data-id="element-157">
                {activePlan.price} ARS
              </p>
              <p className="text-gray-500 font-medium mb-8" data-id="element-158">PAGO ÚNICO</p>

              <a href={activePlan.href} onClick={() => trackPixel('InitiateCheckout', {
              content_name: activePlan.name,
              value: 19990,
              currency: 'ARS'
            })} className="flex items-center justify-center gap-3 w-full max-w-md mx-auto bg-brand-teal hover:bg-brand-dark text-white font-bold py-5 px-8 rounded-xl shadow-[0_8px_30px_rgb(15,118,110,0.3)] hover:shadow-[0_8px_30px_rgb(15,118,110,0.5)] transition-all transform hover:-translate-y-1 text-lg md:text-xl" data-id="element-159">
                {activePlan.cta}
                <ArrowRight size={22} data-id="element-160" />
              </a>
              <p className="text-sm text-gray-400 mt-4 italic" data-id="element-161">
                Podés sumar las especializaciones cuando quieras
              </p>
            </div>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="mb-16" data-id="element-162">
          <h4 className="text-center font-bold text-gray-500 uppercase tracking-wider mb-6" data-id="element-163">
            📱 MEDIOS DE PAGO ACEPTADOS
          </h4>
          <div className="bg-brand-cream rounded-2xl p-6 border border-gray-200" data-id="element-164">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-165">
              <div className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-166">
                <CreditCard className="text-brand-teal" size={20} data-id="element-167" />
                <span data-id="element-168">Tarjeta de crédito</span>
              </div>
              <div className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-169">
                <CreditCard className="text-brand-teal" size={20} data-id="element-170" />
                <span data-id="element-171">Tarjeta de débito</span>
              </div>
              <div className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-172">
                <Smartphone className="text-brand-teal" size={20} data-id="element-173" />
                <span data-id="element-174">Mercado Pago</span>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200 flex items-center justify-center gap-2 text-sm text-gray-500 font-medium" data-id="element-175">
              <Shield size={16} className="text-green-600" data-id="element-176" />
              Pago 100% seguro procesado por Mercado Pago
            </div>

            <div className="mt-6 bg-white rounded-xl p-6 md:p-10 border border-gray-200 shadow-sm" data-id="element-177">
              <img src="https://cdn.magicpatterns.com/uploads/gFuc5vBBojvU2Lu1XykDnU/11111-removebg-preview.png" alt="Pago seguro con Mercado Pago — Visa, Mastercard, American Express, Diners Club" className="w-full h-auto object-contain mx-auto" data-id="element-178" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}